const focusSetter = document.querySelector('[app-focus-method]');

function setFocusInteractionType(element, type) {
    element.setAttribute('data-focus-method', type);
}

window.addEventListener(
    "mousedown",
    () => setFocusInteractionType(focusSetter, 'mouse'),
    
);

window.addEventListener(
    "keydown",
    () => setFocusInteractionType(focusSetter, 'key'),

);

window.addEventListener(
    "touchstart",
    () => setFocusInteractionType(focusSetter, 'touch'),

);



